import { Component, defineComponent } from '@decify/cell-shopify/client';
import './Button.scss';
export const buttonName = 'Button';
export const buttonTagName = 'cell-component-button';
export const buttonClickEvent = 'click';
export class Button extends Component {
    elements;
    defaultInnerHTML;
    constructor() {
        super(buttonName);
        const innerElement = this.querySelector('.Button__Inner');
        if (!innerElement) {
            throw new Error('Inner element not found');
        }
        this.elements = {
            inner: innerElement,
        };
        this.defaultInnerHTML = this.elements.inner.innerHTML;
        this.handleClick = this.handleClick.bind(this);
    }
    componentDidMount() {
        this.elements.inner.subscribe('click', this.handleClick);
    }
    handleClick() {
        this.publish(buttonClickEvent);
    }
    setLoading(loading, { disable = true } = {}) {
        this.elements.inner.setAttribute('aria-busy', loading.toString());
        if (!disable)
            return;
        if (loading) {
            this.elements.inner.setAttribute('disabled', 'disabled');
        }
        else {
            this.elements.inner.removeAttribute('disabled');
        }
    }
    setCompleted(completed) {
        if (completed && this.props.completedContent) {
            this.elements.inner.innerHTML = this.props.completedContent;
        }
        else {
            this.elements.inner.innerHTML = this.defaultInnerHTML;
        }
    }
}
defineComponent(buttonTagName, Button);
